import { CalendarDateService } from '@uplift/services';
import { FinanceTableRow } from './components/FinanceSummaryTable';

type FinanceCsvRow = Pick<FinanceTableRow, 'submittedItemsCount' | 'cashpayItemsCount' | 'insuranceItemsCount' | 'lateFeeSessionsCount' | 'payout'> & {
  month: string;
  year: string;
};
type FinanceCsvHeader = {
  label: string;
  key: keyof FinanceCsvRow;
};

export const convertFinanceRowsToCsvData = (rows: FinanceTableRow[]): { csvData: FinanceCsvRow[]; csvHeaders: FinanceCsvHeader[]} => {
  const csvData = rows.map((row): FinanceCsvRow => {
    const date = CalendarDateService.date(row.date);

    return ({
      ...row,
      month: date.format('MMMM'),
      year: date.format('YYYY'),
    });
  });

  const csvHeaders: FinanceCsvHeader[] = [
    { label: 'Month', key: 'month' },
    { label: 'Year', key: 'year' },
    { label: 'Submitted Sessions', key: 'submittedItemsCount' },
    { label: 'Cash Pay Sessions', key: 'cashpayItemsCount' },
    { label: 'Insurance Sessions', key: 'insuranceItemsCount' },
    { label: 'Cancellation Fees', key: 'lateFeeSessionsCount' },
    { label: 'Payout', key: 'payout' },
  ];

  return { csvData, csvHeaders };
};
